var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSql({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13672 13.3732C8.09694 12.973 7.78125 12.7393 7.26669 12.7393C6.7397 12.7393 6.44886 12.9805 6.44886 13.3086C6.44141 13.674 6.81179 13.8381 7.25426 13.94L7.71165 14.0493C8.59659 14.2482 9.23544 14.6981 9.23792 15.5458C9.23544 16.478 8.50461 17.0721 7.26172 17.0721C6.02628 17.0721 5.23828 16.5028 5.21094 15.4016H6.25248C6.28729 15.9112 6.68998 16.1697 7.24929 16.1697C7.79616 16.1697 8.14914 15.9162 8.15163 15.5433C8.14914 15.2003 7.84091 15.0412 7.28657 14.9069L6.73224 14.7677C5.87216 14.5614 5.34268 14.1314 5.34517 13.3807C5.3402 12.456 6.15802 11.8395 7.27415 11.8395C8.40767 11.8395 9.15341 12.4659 9.16832 13.3732H8.13672ZM14.3371 14.4545C14.3371 15.3618 14.0288 16.0579 13.5317 16.5028L14.26 17.4176H13.2557L12.8456 16.913C12.5722 17.0174 12.2714 17.0696 11.9532 17.0696C10.596 17.0696 9.56932 16.1126 9.56932 14.4545C9.56932 12.7891 10.596 11.8395 11.9532 11.8395C13.303 11.8395 14.3371 12.7891 14.3371 14.4545ZM11.5803 15.2301H12.4951L12.8729 15.7148C13.1091 15.4339 13.2458 15.0089 13.2458 14.4545C13.2458 13.3757 12.7337 12.7915 11.9532 12.7915C11.1702 12.7915 10.6606 13.3757 10.6606 14.4545C10.6606 15.5334 11.1702 16.1175 11.9532 16.1175C12.0501 16.1175 12.1446 16.1076 12.2316 16.0902L11.5803 15.2301ZM14.8375 17V11.9091H15.9138V16.1126H18.0964V17H14.8375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 3.09113 6.09175 2 11.5 2C16.9083 2 21 3.09113 21 6V19C21 21.9089 16.9083 23 11.5 23C6.09175 23 2 21.9089 2 19V6ZM4 8.7775V19C4 20.1046 7.35786 21 11.5 21C15.6421 21 19 20.1046 19 19V8.7775C17.2886 9.63866 14.6123 10 11.5 10C8.38773 10 5.71143 9.63866 4 8.7775ZM18.994 5.91956C18.8357 4.85228 15.5411 4 11.5 4C7.35786 4 4 4.89543 4 6C4 7.10457 7.35786 8 11.5 8C15.6421 8 19 7.10457 19 6L18.994 5.91956Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default ForwardRef;